import { useMutation, useQueryClient } from "@tanstack/react-query";

import apiClient from "@/lib/api-client";
import type { ZoteroSyncEvent } from "@/types/zoteroSync";

export function useRetryEvent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (eventId: string) =>
      apiClient
        .post(`api/zotero-sync/events/${eventId}/retry`, {
          // Retry path = parent fetch + blob download + R2 upload +
          // sha256 + PDF text extraction. Routinely exceeds the 10s
          // default. See CLAUDE.md rule #9 / IMPL.md "ky Timeout".
          timeout: 120_000,
        })
        .json<ZoteroSyncEvent>(),
    onSettled: () => {
      // Retry may (a) update reason in place on still-broken, or
      // (b) leave the original skipped_blob_unreachable row and let
      // attach() write a fresh event for the new outcome. Invalidate
      // all three event lists — the new fresh event could land in
      // unmatched, matched, OR (if Zotero is still broken) the stuck
      // list keeps the row with an updated reason.
      qc.invalidateQueries({
        queryKey: ["zotero-sync-events", "skipped_blob_unreachable"],
      });
      qc.invalidateQueries({ queryKey: ["zotero-sync-events", "unmatched"] });
      qc.invalidateQueries({ queryKey: ["zotero-sync-events", "matched"] });
    },
  });
}
